@import "config";

.container {
	@include flex(column, center, center);

	width: 100%;
	height: 100%;
	gap: $spacing-stack-xxl;
}

.title {
	font-size: $font-size-md;
	font-weight: $font-weight-bold;
	color: $color-dark-d2;
	text-align: center;
}

.description {
	@extend .title;

	font-size: $font-size-xs;
}

.footer {
	@include flex(row, unset, center);

	width: 100%;
	gap: $spacing-inline-xxxs;

	button {
		width: 100%;
	}
}
